import { ReactElement } from 'react';

import {
   CurrentHealthcareProviderPaymentsConfigurationQuery,
   CurrentHealthcareProviderPaymentsConfigurationTermsOfServiceUpdateCommand,
} from '@dreryk/egabinet-online-payments-integration-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { PromiseVoidFunction } from '@dreryk/react-common';
import { dispatchSnackbarNegativeEvent, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { onlinePaymentsProviderDetailsTranslationKeys } from '../../translations';

import {
   OnlinePaymentsUpdateTermsOfServiceDocumentFormBean,
   OnlinePaymentsUpdateTermsOfServiceDocumentFormController,
} from './OnlinePaymentsUpdateTermsOfServiceDocumentModal.types';

type OnlinePaymentsTermsOfServiceUpdateActionChildrenRenderProps = {
   readonly updateTermsOfService: PromiseVoidFunction;
};

type OnlinePaymentsTermsOfServiceUpdateActionProps = Pick<
   OnlinePaymentsUpdateTermsOfServiceDocumentFormController,
   'handleSubmit'
> & {
   readonly onSuccess: VoidFunction;
   readonly children: (renderProps: OnlinePaymentsTermsOfServiceUpdateActionChildrenRenderProps) => ReactElement;
};

export const OnlinePaymentsTermsOfServiceUpdateAction = (
   props: OnlinePaymentsTermsOfServiceUpdateActionProps
): ReactElement => {
   const { executeAsync: updateTermsOfServiceDocument } = useCqrsCommand<
      void,
      OnlinePaymentsUpdateTermsOfServiceDocumentFormBean
   >(
      (parameters) => {
         const command = new CurrentHealthcareProviderPaymentsConfigurationTermsOfServiceUpdateCommand();
         command.termsOfService = parameters.termsOfService!;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               onlinePaymentsProviderDetailsTranslationKeys.updateTermsOfServiceDocumentModal.actions.saveDocument
                  .successMessage
            );
            refetchCqrsQuery(CurrentHealthcareProviderPaymentsConfigurationQuery);
            props.onSuccess();
         },
         onUnexpectedError: () => {
            dispatchSnackbarNegativeEvent(
               onlinePaymentsProviderDetailsTranslationKeys.updateTermsOfServiceDocumentModal.actions.saveDocument
                  .failureMessage
            );
         },
      }
   );

   return props.children({
      updateTermsOfService: props.handleSubmit(updateTermsOfServiceDocument),
   });
};
